import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IntroId } from '../enums/intro-id.enum';
import { IntroFinished } from '../interfaces';

@Injectable({ providedIn: 'root' })
export class TagsApiService {
  constructor(private http: HttpClient) {}

  getIntroFinished(introId: IntroId): Observable<IntroFinished> {
    if (introId === IntroId.PRS) {
      return this.http.get<IntroFinished>('/api/prs/intro/status');
    } else if (introId == IntroId.ORAL_MICROBIOME) {
      return this.http.get<IntroFinished>('/api/microbiome/intro/status');
    }
  }

  postIntroFinished(introId: IntroId): Observable<any> {
    if (introId === IntroId.PRS) {
      return this.http.post('/api/prs/intro/finish', {});
    } else if (introId == IntroId.ORAL_MICROBIOME) {
      return this.http.post('/api/microbiome/intro/finish', {});
    }
  }
}
